function fixedMenu() {
    jQuery(function($) {
        const header = $('header.set_menu_devices');
        window.addEventListener('scroll', () => {
            const scroll = window.scrollY;
            if( scroll > 100 ) {
                header.addClass('bg-tap-header');
            } else {
                header.removeClass('bg-tap-header');
            }
        });
    })
}

function fixedHeaderMobile() {
    jQuery(function($) {
        const header = $('.section_header_top');

        window.addEventListener('scroll', () => {
            let width_screen = $(window).width();
            console.log('width_screen');
            console.log(width_screen);
            const scroll = window.scrollY;
            if( scroll > 50 && width_screen <= 991 ) {
                header.addClass('header_mobile_fixed');
            } else {
                header.removeClass('header_mobile_fixed');
            }
        });
    })
}

export { fixedMenu, fixedHeaderMobile }
